// import Vue from 'vue'
// import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        width: 0,
        height: 0,
        displayInfosBanner: false
    },
    getters: {
        width: state => state.width,
        height: state => state.height,
        displayInfosBanner: state => state.displayInfosBanner,
    },
    mutations: {
        SETUP(state, app) {
            state.width = app.width
            state.height = app.height
        },
        CHANGE_INFOS_BANNER(state) {
            state.displayInfosBanner = !state.displayInfosBanner
        }
    },
    actions: {
        appSetup({ commit }, payload) {
            commit("SETUP", {
                width: window.innerWidth,
                height: window.innerHeight
            })
        },
        changeInfosBanner({ state, commit }) {
            commit("CHANGE_INFOS_BANNER");
        }
    }
})